import "./PricingSection.css";

function PricingSection({
  formData,
  updateField,
}) {
  return (
    <div className="bakery-form-section">

      <h3 className="section-title">
        Pricing & Preparation
      </h3>

      <div className="bakery-form-grid">

        <div className="form-group">
          <label>Original Price (₹)</label>

          <input
            type="number"
            min="0"
            placeholder="Enter original price"
            value={formData.price}
            onChange={(e) =>
              updateField("price", e.target.value)
            }
          />
        </div>

        <div className="form-group">
          <label>Offer Price (₹)</label>

          <input
            type="number"
            min="0"
            placeholder="Enter offer price"
            value={formData.offerPrice}
            onChange={(e) =>
              updateField("offerPrice", e.target.value)
            }
          />
        </div>

        <div className="form-group">
          <label>Weight / Size</label>

          <select
            value={formData.weight}
            onChange={(e) =>
              updateField("weight", e.target.value)
            }
          >
            <option value="">Select Weight</option>
            <option value="250 g">250 g</option>
            <option value="500 g">500 g</option>
            <option value="750 g">750 g</option>
            <option value="1 Kg">1 Kg</option>
            <option value="1.5 Kg">1.5 Kg</option>
            <option value="2 Kg">2 Kg</option>
            <option value="Custom">Custom</option>
          </select>
        </div>

        <div className="form-group">
          <label>Preparation Time</label>

          <select
            value={formData.preparationTime}
            onChange={(e) =>
              updateField("preparationTime", e.target.value)
            }
          >
            <option value="">Select Time</option>
            <option value="15 mins">15 mins</option>
            <option value="30 mins">30 mins</option>
            <option value="45 mins">45 mins</option>
            <option value="1 Hour">1 Hour</option>
            <option value="2 Hours">2 Hours</option>
            <option value="4 Hours">4 Hours</option>
            <option value="1 Day">1 Day</option>
            <option value="2 Days">2 Days</option>
          </select>
        </div>

      </div>

    </div>
  );
}

export default PricingSection;